import { CommonActionType } from '../common/common-actions';
export const RegisterActionType = {
    ...CommonActionType,
    REGISTER_USER: 'REGISTER_USER',
    REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
    REGISTER_USER_FAILED: 'REGISTER_USER_FAILED',
    CLEAR_REGISTER_ERRORS: 'CLEAR_REGISTER_ERRORS',
    CLEAR_REGISTER_STATE: 'CLEAR_REGISTER_STATE',
};
